.banner {
    padding: 16px;
    background-color: #ebf5fb;
    border-bottom: 1px solid var(--light-gray);
}
